import { ElementRef, InjectionToken } from '@angular/core';
import { z } from 'zod';

export const RateSchema = z.object({
    date: z.date(),
    rate: z.number(),
});
export const DataRateSchema = z.object({
    rates: z.array(RateSchema),
});

export const TL_NTL_SPOT_URL = new InjectionToken<string>('TL_NTL_SPOT_URL');
export const TRENDLINES_NTL_SPOT_VAN_DOC = 'trendlines_ntl_spot_van_doc';
export const TRENDLINES_NTL_SPOT_REEFER_DOC = 'trendlines_ntl_spot_reefer_doc';
export const TRENDLINES_NTL_SPOT_FLATBED_DOC =
    'trendlines_ntl_spot_flatbed_doc';
export const TRENDLINES_CACHE_DB = 'trendlines-cache';

export type Rate = z.infer<typeof RateSchema>;
export type DataRate = z.infer<typeof DataRateSchema>;

export type CachedNtlRates = {
    rates: Rate[];
    expiryDate: string;
};

export interface IIqTrendlinesNtlSpotStateService {
    flatbedGraph(container: ElementRef, rates: DataRate): void | Promise<void>;
    reeferGraph(container: ElementRef<any>, rates: DataRate): void | Promise<void>;
    vanGraph(container: ElementRef<any>, rates: DataRate): void | Promise<void>;
    vanData(): void | Promise<DataRate>;
    reeferData(): void | Promise<DataRate>;
    flatbedData(): void | Promise<DataRate>;
}
